module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"badge":"AI 尺寸推薦"}}')
  delete Component.options._Ctor
}
